<template>
    <div class="review">
        <div v-if="this.reviewProductsDataLocal.length > 0" class="review-container">
          <div class="review-title">Rate your experience</div>
              <ul>
                <li v-for="(item,index) in this.reviewProductsDataLocal" class="review-per-row">

                  <div class="row-container-1">
                    <img :src="item.Thumbnail" alt="">
                  </div>
                  <div class="row-container-2">
                    <p class="brand" @click="onClickBrand" v-if="item.Brand">{{item.Brand}}</p>
                    <p v-if="$i18n.locale == 'en'" class="name">{{item.Name}}</p>
                    <p v-if="$i18n.locale == 'ch'" class="name">{{item.Description}}</p>
                  </div>
                  <div class="row-container-3">
                    <p class="name">${{item.Price ? item.Price.toFixed(2) : ''}}</p>
                  </div>
                  <div class="row-container-4">
                    <p class="experience">RATE YOUR EXPERIENCE</p>
                    <div class="star-img-container">
                        <img v-for="(item_t2,index_t2) in (index===currentHoverIndex) ? item.hoverStars : item.starIndex" @click="onClickStar(index, index_t2)" @mouseleave="onLeaveStars()" @mouseover="onHoverStars(index, index_t2)" :data-index="index_t2" :key="index_t2" class="star-img" :src="item_t2" alt="">
                    </div>
                  </div>
                </li>
              </ul>
        </div>
        <div v-else class="review-container-empty">
          <div class="empty-title">{{$t('you_havenot_purchased')}}</div>
          <button @click="continueShopping" class="empty-button">{{ $t('continueShopping') }}</button>
        </div>

    </div>
</template>


<script>
import { mapActions, mapState, mapMutations } from "vuex";
import star0 from '../../assets/img/star0.jpg'
import star1 from '../../assets/img/star1.jpg'
import star2 from '../../assets/img/star2.jpg'
// import Router from "../router";
// import { isUserAuthenticated } from "../store/modules/cart";
export default {
  name: "Review",
  data() {
    return {
      subValue: null,
      reviewProductsDataLocal: [],
      currentHoverIndex: null,

      submitLoading: false,
  };
  },
  methods: {
    ...mapActions('profile', ['fetchSubscribeEmail', 'postSubscribeEmail', 'putUnsubscribeEmail', 'fetchProductReviews', 'submitProductReviews']),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility']),
    hoverActive(index, status) {
      if (status) {
        this.currentHoverIndex = index;
      } else {
        this.currentHoverIndex = null;
      }
    },
    onHoverStars(index1, index2) {
      this.currentHoverIndex = index1;
      this.reviewProductsDataLocal[index1].hoverStars = [star0, star0, star0, star0, star0];
      for (let i=0; i<=index2; i++) {
        this.reviewProductsDataLocal[index1].hoverStars[i] = star2;
      }
    },
    onLeaveStars() {
      this.currentHoverIndex = null;
    },
    onClickStar(index1, index2) {
      let data = { Product_id: this.reviewProductsDataLocal[index1].Product_id, SalesOrderLine_id: this.reviewProductsDataLocal[index1].SalesOrderLine_id, star: index2+1 };
      this.submitLoading = true;
      this.submitProductReviews(data)
      .then(res => {
        this.submitLoading = false;
        this.fetchProductReviews();
        setTimeout(() => {
          this.onHoverStars(index1, index2);
        }, 800);
      }).catch(err => {
        this.submitLoading = false;
      });
    },
    onClickBrand(item) {

    },
    continueShopping() {
      this.$router.push('/collections');
    },
  },
//   beforeRouteLeave(to, from, next) {
//     next();
//   },
  mounted() {
      this.fetchProductReviews();
  },
  watch: {
    $route(to, from) {

    },
    reviewProductsData: function(newVal, oldVal) {
      let temp = [];
      let star = [];
      let hoverStars = [star0, star0, star0, star0, star0];
      newVal.map(prod => {
        star = [];
        if (prod.star || prod.star === 0) {
          for (let i=1; i<6; i++) {
            if (prod.star >= i) {
            star.push(star2);
            } else if (prod.star > (i-1) && prod.star < i) {
            star.push(star1);
            } else if (prod.star <= (i-1)) {
            star.push(star0);
            }
          }
        } else {
          star = [star0, star0, star0, star0, star0];
        }
        temp.push({ starIndex: star, hoverStars, ...prod});
      });
      this.reviewProductsDataLocal = temp;
    },
  },
  computed: mapState({
    reviewProductsData: state => state.profile.reviewProductsData,
  }),
};

</script>
​
<style scoped lang="less">
@import "../../assets/css/public";
@import "../../assets/css/reviewProducts";
</style>



// WEBPACK FOOTER //
// src/view/Profile/reviewProducts.vue